import { useRouter } from 'next/router'
import React, { useCallback, useRef } from 'react'

import { toBase64, fromBase64 } from '../../helpers'

import Styled from './ObfuscatedNavLink.styled'

const ObfuscatedNavLink = ({
  children,
  className,
  to,
  title,
  ariaLabel,
  disabled,
}) => {
  const obfuscatedHref = toBase64(to)
  const obfuscatedLinkRef = useRef()
  const router = useRouter()

  const handleClick = useCallback(() => {
    if (obfuscatedLinkRef && obfuscatedLinkRef.current && !disabled) {
      router.push(fromBase64(obfuscatedLinkRef.current.dataset.o))
    }
  }, [router, disabled])

  return (
    <Styled
      ref={obfuscatedLinkRef}
      data-o={obfuscatedHref}
      onClick={handleClick}
      title={title}
      className={className}
      aria-label={ariaLabel}
      disabled={disabled}
    >
      {children}
    </Styled>
  )
}

ObfuscatedNavLink.defaultProps = {
  disabled: false,
}

export default ObfuscatedNavLink
